module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-F"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dialogVisible),
      expression: "!dialogVisible"
    }],
    staticStyle: {
      "display": "grid",
      "place-items": "end",
      "width": "250px",
      "position": "absolute",
      "right": "10px",
      "z-index": "1999"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "主题"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": function (val) { return _vm.handleChangeTheme(val); }
    },
    model: {
      value: (_vm.chartTheme),
      callback: function($$v) {
        _vm.chartTheme = $$v
      },
      expression: "chartTheme"
    }
  }, _vm._l((_vm.themes), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "企业情况",
      "name": "1"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("出版单位音像电子资质统计")]), _vm._v(" "), _c('p', [_vm._v("\n                音像电子出版单位总数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums[0]))]), _vm._v(" 家\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                既有音像又有电子资质的出版单位数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums[1]))]), _vm._v(" 家\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                只有音像资质的出版单位数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums[2]))]), _vm._v(" 家\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                只有电子资质的出版单位数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums[3]))]), _vm._v(" 家\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                具有音像资质的出版单位数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums[4]))]), _vm._v(" 家\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                具有电子资质的出版单位数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums[5]))]), _vm._v(" 家\n              ")])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('hbar-chart', {
    key: _vm.roundKey + '_2',
    attrs: {
      "params": {
        id: 'chart_2',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("出版单位出版资质统计")]), _vm._v(" "), _c('p', [_vm._v("\n                具有图书资质的出版单位数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums2[0]))]), _vm._v(" 家\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                具有期刊资质的出版单位数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums2[1]))]), _vm._v(" 家\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                具有报纸资质的出版单位数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums2[2]))]), _vm._v(" 家\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                具有网络资质的出版单位数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums2[3]))]), _vm._v(" 家\n              ")])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_3',
    attrs: {
      "params": {
        id: 'chart_3',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  }), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-30px"
    },
    attrs: {
      "id": "sel_chart_3",
      "span": 24
    }
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "padding": "0px 0px 10px 0px"
    },
    on: {
      "change": _vm.chagenZjVal
    },
    model: {
      value: (_vm.checkListZj),
      callback: function($$v) {
        _vm.checkListZj = $$v
      },
      expression: "checkListZj"
    }
  }, _vm._l((_vm.listZj), function(name, index) {
    return _c('el-checkbox', {
      key: name,
      attrs: {
        "label": name
      }
    })
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_5',
    attrs: {
      "params": {
        id: 'chart_5',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_4',
    attrs: {
      "params": {
        id: 'chart_4',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  }), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-30px"
    },
    attrs: {
      "id": "sel_chart_4",
      "span": 24
    }
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "padding": "0px 0px 10px 0px"
    },
    on: {
      "change": _vm.chagenZjVal2
    },
    model: {
      value: (_vm.checkListZj2),
      callback: function($$v) {
        _vm.checkListZj2 = $$v
      },
      expression: "checkListZj2"
    }
  }, _vm._l((_vm.listZj2), function(name, index) {
    return _c('el-checkbox', {
      key: name,
      attrs: {
        "label": name
      }
    })
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("单位性质统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_7'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_7"][key]))]), _vm._v(" 家\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_7',
    attrs: {
      "params": {
        id: 'chart_7',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("法人类型统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_6'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_6"][key]))]), _vm._v(" 家\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_6',
    attrs: {
      "params": {
        id: 'chart_6',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "音像制品",
      "name": "3"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('mbar-chart', {
    key: _vm.roundKey + '_183',
    attrs: {
      "params": {
        id: 'chart_183',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData,
      "barType": 'line'
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_181',
    attrs: {
      "params": {
        id: 'chart_181',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData,
      "barType": 'line'
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('mbar-chart', {
    key: _vm.roundKey + '_182',
    attrs: {
      "params": {
        id: 'chart_182',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData,
      "barType": 'line'
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度音像出版单位出版品种数分段统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_11'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                出版品种为" + _vm._s(key) + "的出版单位："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_11"][key]))]), _vm._v(" 家\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_11',
    attrs: {
      "params": {
        id: 'chart_11',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度音像制品载体形式统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_15'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "的数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_15"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_15',
    attrs: {
      "params": {
        id: 'chart_15',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度音像制品内容来源类型统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_13'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                内容来源类型" + _vm._s(key) + "数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_13"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_13',
    attrs: {
      "params": {
        id: 'chart_13',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度音像制品节目时长分段统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_12'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                时长分段" + _vm._s(key) + "的节目数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_12"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_12',
    attrs: {
      "params": {
        id: 'chart_12',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度音像制品书配盘统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_14'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                书配盘" + _vm._s(key) + "的数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_14"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_14',
    attrs: {
      "params": {
        id: 'chart_14',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度除传统光盘载体外音像制品出版单位拓展方向分布情况")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_17'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_17"][key]))]), _vm._v(" 家\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_17',
    attrs: {
      "params": {
        id: 'chart_17',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年音像制品出版单位结合音像电子业务开设并运营的项目分布情况")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_18'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "的数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_18"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_18',
    attrs: {
      "params": {
        id: 'chart_18',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "电子出版物",
      "name": "4"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('mbar-chart', {
    key: _vm.roundKey + '_283',
    attrs: {
      "params": {
        id: 'chart_283',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData,
      "barType": 'line'
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_281',
    attrs: {
      "params": {
        id: 'chart_281',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData,
      "barType": 'line'
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('mbar-chart', {
    key: _vm.roundKey + '_282',
    attrs: {
      "params": {
        id: 'chart_282',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData,
      "barType": 'line'
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度电子出版单位出版品种数分段统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_21'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                出版品种为" + _vm._s(key) + "的出版单位："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_21"][key]))]), _vm._v(" 家\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_21',
    attrs: {
      "params": {
        id: 'chart_21',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度电子载体形式统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_25'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "的数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_25"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_25',
    attrs: {
      "params": {
        id: 'chart_25',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度电子出版物内容来源类型统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_23'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                内容来源类型" + _vm._s(key) + "数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_23"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_23',
    attrs: {
      "params": {
        id: 'chart_23',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度电子出版物数据容量分段统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_22'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                数据容量分段" + _vm._s(key) + "的节目数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_22"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_22',
    attrs: {
      "params": {
        id: 'chart_22',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度电子出版物书配盘统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_24'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                书配盘" + _vm._s(key) + "的数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_24"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_24',
    attrs: {
      "params": {
        id: 'chart_24',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度除传统光盘载体外电子出版物出版单位拓展方向分布情况")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_27'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_27"][key]))]), _vm._v(" 家\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_27',
    attrs: {
      "params": {
        id: 'chart_27',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年电子出版物出版单位结合音像电子业务开设并运营的项目分布情况")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_28'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "的数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_28"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_28',
    attrs: {
      "params": {
        id: 'chart_28',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "经营情况",
      "name": "business"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('mbar-chart', {
    key: _vm.roundKey + '_51',
    attrs: {
      "params": {
        id: 'chart_51',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('mbar-chart', {
    key: _vm.roundKey + '_52',
    attrs: {
      "params": {
        id: 'chart_52',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "15px",
      "padding": "0px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('chart-finance', {
    staticStyle: {
      "padding": "0px",
      "width": "100%"
    },
    attrs: {
      "chart-theme": this.chartTheme,
      "active-name": this.activeName
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "15px",
      "padding": "0px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('province-finance', {
    staticStyle: {
      "padding": "0px",
      "width": "100%"
    },
    attrs: {
      "chart-theme": this.chartTheme,
      "active-name": this.activeName
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "人员整体情况",
      "name": "worker"
    }
  }, [_c('worker-base', {
    staticStyle: {
      "padding": "0px",
      "width": "100%"
    },
    attrs: {
      "chart-theme": this.chartTheme,
      "active-name": this.activeName
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "各单位人员情况",
      "name": "5"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("音像电子人员职称统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_38'])), function(key, index) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(index == 0 ? key : key + "职称") + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_38"][key]))])])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_38',
    attrs: {
      "params": {
        id: 'chart_38',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("职称系列统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_37'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_37"][key]))])])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_37',
    attrs: {
      "params": {
        id: 'chart_37',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("出版专业人员职称统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_39'])), function(key, index) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(index == 0 ? key : key + "职称") + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_39"][key]))]), _vm._v("\n                人\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_39',
    attrs: {
      "params": {
        id: 'chart_39',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("领导班子成员持证上岗率统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_45'])), function(key, index) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_45"][key]))])])
  }), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_41'])), function(key, index) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_41"][key]))])])
  }), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_44'])), function(key, index) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_44"][key]))])])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_45',
    attrs: {
      "params": {
        id: 'chart_45',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_41',
    attrs: {
      "params": {
        id: 'chart_41',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_44',
    attrs: {
      "params": {
        id: 'chart_44',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("编辑人员统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_42'])), function(key, index) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_42"][key]))])])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_42',
    attrs: {
      "params": {
        id: 'chart_42',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_46',
    attrs: {
      "params": {
        id: 'chart_46',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_47',
    attrs: {
      "params": {
        id: 'chart_47',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("政治面貌统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_35'])), function(key) {
    return _c('p', {
      key: key,
      staticStyle: {
        "width": "40%",
        "float": "left",
        "margin-bottom": "0px"
      }
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_35"][key]))])])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_35',
    attrs: {
      "params": {
        id: 'chart_35',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("文化程度统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_36'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_36"][key]))])])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_36',
    attrs: {
      "params": {
        id: 'chart_36',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("出版专业职业资格中级及以上职称占比统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_32'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                中级及以上职称占比" + _vm._s(key) + "数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_32"][key]))]), _vm._v(" 家\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_32',
    attrs: {
      "params": {
        id: 'chart_32',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("领导班子出版专业职业资格证书中级及以上占比统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_34'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                领导班子出版专业职业资格证书中级及以上占比" + _vm._s(key) + "数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_34"][key]))]), _vm._v("\n                家\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_34',
    attrs: {
      "params": {
        id: 'chart_34',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("各专业高级职称编辑人数统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_40'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                各专业高级职称编辑" + _vm._s(key) + "的人数："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_40"][key]))]), _vm._v(" 人\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_40',
    attrs: {
      "params": {
        id: 'chart_40',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("各专业中级职称编辑人数统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_43'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                各专业中级职称编辑" + _vm._s(key) + "的人数："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_43"][key]))]), _vm._v(" 人\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_43',
    attrs: {
      "params": {
        id: 'chart_43',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "连续型电子出版物",
      "name": "lxdzfinace"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "0px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('lxdz-finance', {
    staticStyle: {
      "padding": "0px",
      "width": "100%"
    },
    attrs: {
      "chart-theme": this.chartTheme,
      "active-name": this.activeName
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "top": "6vh",
      "destroy-on-close": true,
      "visible": _vm.dialogVisible,
      "width": "94%"
    },
    on: {
      "opened": _vm.openedDialog,
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "panel panel-default panel-intro"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "myTabContent"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "echart_n"
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "echart_table",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "echart_n_table"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "34px",
      "line-height": "34px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "60px",
      "float": "left",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-download searchFilerCls",
    attrs: {
      "aria-hidden": "true",
      "title": "导出"
    },
    on: {
      "click": function($event) {
        _vm.downloadData('chart_n')
      }
    }
  })]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "calc(100% - 60px)",
      "float": "left"
    },
    attrs: {
      "gutter": 15
    }
  }, _vm._l((_vm.currentId ? Object.keys(_vm.columnMap[_vm.currentId]) : []), function(key, index) {
    return _c('el-col', {
      key: key,
      attrs: {
        "span": (_vm.currentId ? Object.keys(_vm.columnMap[_vm.currentId]) : []).length <= 4 ? 6 : 4
      }
    }, [(
      (_vm.currentId == 'chart_11' ||
        _vm.currentId == 'chart_12' ||
        _vm.currentId == 'chart_21' ||
        _vm.currentId == 'chart_22') &&
      key == 'value'
    ) ? _c('el-select', {
      attrs: {
        "size": "mini",
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.searchData('chart_n')
        }
      },
      model: {
        value: (_vm.queryFilterN[key]),
        callback: function($$v) {
          _vm.$set(_vm.queryFilterN, key, $$v)
        },
        expression: "queryFilterN[key]"
      }
    }, _vm._l((Object.keys(_vm.rangeValus)), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    })) : _c('el-input', {
      staticClass: "searchInput",
      staticStyle: {
        "margin-top": "0px",
        "margin-bottom": "3px"
      },
      attrs: {
        "clearable": "",
        "size": "mini",
        "placeholder": '请输入' + _vm.columnMap[_vm.currentId][key]
      },
      on: {
        "input": function($event) {
          _vm.onInput()
        }
      },
      model: {
        value: (_vm.queryFilterN[key]),
        callback: function($$v) {
          _vm.$set(_vm.queryFilterN, key, $$v)
        },
        expression: "queryFilterN[key]"
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "append",
        "size": "mini",
        "icon": "el-icon-search"
      },
      on: {
        "click": function($event) {
          _vm.searchData('chart_n')
        }
      },
      slot: "append"
    })], 1)], 1)
  }))], 1), _vm._v(" "), _c('table', {
    staticClass: "tabletemp table-striped table-bordered tabletemp-hover",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "echart_n_tab"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "th-inner",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": "返回"
    },
    on: {
      "click": function($event) {
        _vm.backEcharts('chart_n')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fht-cell"
  })]), _vm._v(" "), _vm._l((_vm.currentId ? Object.keys(_vm.columnMap[_vm.currentId]) : []), function(key, index) {
    return _c('th', {
      key: key,
      attrs: {
        "nowrap": "nowrap"
      }
    }, [_c('div', {
      staticClass: "th-inner text-warning"
    }, [_vm._v("\n                            " + _vm._s(_vm.columnMap[_vm.currentId][key]) + "\n                            "), _c('i', {
      class: _vm.querySort['chart_n'][key] == 'sort' ?
        'fa fa-sort' :
        _vm.querySort['chart_n'][key] == 'asc' ?
        'fa fa-sort-asc' :
        _vm.querySort['chart_n'][key] == 'desc' ?
        'fa fa-sort-desc' :
        '',
      style: (_vm.querySort['chart_n'][key] == 'sort' ? 'color: #e3dfdfff' : ''),
      on: {
        "click": function($event) {
          _vm.sortData('chart_n', key, _vm.querySort['chart_n'][key])
        }
      }
    })])])
  })], 2)]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "font-size": "14px !important"
    },
    attrs: {
      "id": "echart_n_html"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle"
    },
    attrs: {
      "colspan": "99"
    }
  }, [_vm._v("加载中...")])])])])])])], 1)], 1)], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70e2a552"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adminRole/chart1.vue
// module id = 1773
// module chunks = 1